export default __webpack_public_path__ + "media/images/dashed-line-lg-47fb1474148caaeaca3f097a6cc62df2.svg";